import { render, staticRenderFns } from "./TUIOrderPaymentStatusChip.vue?vue&type=template&id=436868a6"
import script from "./TUIOrderPaymentStatusChip.vue?vue&type=script&lang=js"
export * from "./TUIOrderPaymentStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports